module.exports = __webpack_public_path__ + "static/media/Sonasafe_R_214x74.a5abb506.png";